export default __webpack_public_path__ + "static/whiteboard-43f46914ae2aab986e87e04d5802ba57.jpg";